import * as DashboardConstants from '.././DashboardConstants';

export const errorTableHeaders = [
    {
        key: 'orderId',
        header: DashboardConstants.OrderId
    },
    {
        key: 'orderNumber',
        header:DashboardConstants.OrderNumber
    },
    {
        key: 'error',
        header: DashboardConstants.Error
    },
    {
        key: 'incidentNumber',
        header: DashboardConstants.IncidentNumber
    },
    {
        key: 'assignedTo',
        header: DashboardConstants.AssignedTo
    },
];